import { render, staticRenderFns } from "./Dashboard.vue?vue&type=template&id=7a203338&scoped=true&"
import script from "@/views/Users/Teacher/Dashboard.ts?vue&type=script&lang=ts&"
export * from "@/views/Users/Teacher/Dashboard.ts?vue&type=script&lang=ts&"
import style0 from "@/views/Users/Teacher/dashboard.scss?vue&type=style&index=0&id=7a203338&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a203338",
  null
  
)

export default component.exports